<template>
  <BaseDialog
    :visible="visible"
    @update:visible="(val) => emit('update:visible', val)"
    class="sm:!w-[90%] md:!w-[50%] h-[80vh] sm:h-[85vh] md:h-[90vh] md:rounded-[16px] rounded-[12px]"
    height="auto"
    :draggable="false"
  >
    <div class="flex justify-end items-center pt-4 pr-4">
      <button
        @click="emit('update:visible', false)"
        class="cursor-pointer border-none bg-transparent flex justify-center items-center"
        v-html="cancelSvg"
        :aria-label="$t('accessibilityLabels.close')"
        :autofocus="visible ? true : false"
      ></button>
    </div>

    <div class="flex justify-center pb-[32px]">
      <div
        class="z-0 bg-gradient-to-r rounded-full flex items-center justify-center from-warningBgGradient p-3 opacity-25 to-warningBgGradientVia"
        v-html="tooltip({ width: '48', height: '48', color: '#FFFFFF' })"
      ></div>
      <div
        class="z-10 bg-gradient-to-r rounded-full flex items-center justify-center from-mintGradientFrom to-mintGradientTo p-3 ml-[-10px]"
        v-html="
          accountAgentSvg({ width: '48', height: '48', color: '#FFFFFF' })
        "
      ></div>
    </div>

    <div class="flex items-center justify-center mb-[32px] mx-6">
      <p
        class="font-just font-400 text-[24px] leading-[100%] text-btnActive"
        v-html="title"
      ></p>
    </div>

    <div class="flex items-center justify-center mb-[32px] mx-6">
      <p
        class="font-just text-[20px] leading-[100%] font-400"
        v-html="subtitle"
      ></p>
    </div>
    <div class="flex gap-[32px] px-[32px] py-[24px] justify-center mx-6">
      <div
        class="bg-white rounded-[16px] border-[1.2px] border-solid gap-4 border-lightGrayBorder font-just shadow-sm p-6 flex flex-col items-center"
      >
        <div class="flex items-center justify-center relative mb-2">
          <div class="relative">
            <img
              v-if="item?.image"
              :src="item?.image"
              alt="avatar"
              class="w-[48px] h-[48px] object-cover rounded-full"
            />
            <img
              v-if="item?.badgeIcon"
              :src="item?.badgeIcon"
              alt="icon"
              class="w-[33px] h-[33px] absolute -right-6 top-1/2 -translate-y-1/2"
            />
          </div>
          <span
            class="ml-8 font-just font-400 text-[16px] text-greyLight"
            v-if="item?.tag"
          >
            {{ $te(item.tag) ? $t(item.tag) : ($te(`${item.tag}.name`) ? $t(`${item.tag}.name`) : item.tag) }}
          </span>
        </div>
        <span
          class="font-just font-semibold text-[20px] text-darkBlue text-center w-full"
          v-if="item?.name"
        >
          {{ item?.name }}
        </span>
      </div>
    </div>
    <div class="w-full pt-[32px] px-[24px]">
      <BaseButton
        :label="$t('commonLabels.done')"
        class="w-full"
        @click="handleSubmit"
      />
    </div>

    <div class="flex items-center justify-center py-[16px]">
      <p
        @click="emit('update:visible', false)"
        class="underline cursor-pointer font-just font-400 text-[16px] leading-[24px] tracking-[-0.2%]"
      >
        {{ $t('documentLabels.maybeLater') }}
      </p>
    </div>
  </BaseDialog>
</template>

<script setup>
import { ref, computed } from "vue";
import { closeSvg, tooltip, accountAgentSvg } from "@/utils/commonSvg";

const fullscreen = ref(true);
const cancelSvg = computed(() =>
  closeSvg({
    height: fullscreen.value ? "32px" : "24px",
    width: fullscreen.value ? "32px" : "24px",
  })
);

const emit = defineEmits(["update:visible", "validateContinue"]);
const props = defineProps({
  visible: Boolean,
  showCancel: {
    type: Boolean,
    default: true,
  },
  item: { required: true },
  title: {},
  subtitle: {},
});

const handleSubmit = () => {
  emit("validateContinue");
};
</script>
